var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.file
      ? _c("div", [
          _c("input", {
            ref: "fileInput",
            staticClass: "custom-file-input",
            staticStyle: { display: "none" },
            attrs: { type: "file", accept: _vm.$props.accept },
            on: { change: _vm.handleFileSelected },
          }),
          _vm._v(" "),
          _c(
            "div",
            { on: { click: _vm.clickFileInput } },
            [
              _vm._t("default", function () {
                return [
                  _c("button", { staticClass: "btn btn-outline-secondary" }, [
                    _vm._v("Upload file"),
                  ]),
                ]
              }),
            ],
            2
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.$props.skipConfirmation && _vm.file && !_vm.uploading
      ? _c(
          "div",
          [
            _vm._t("file", function () {
              return [
                _c("p", [
                  _vm._v("\n                Selected file: "),
                  _c("strong", [_vm._v(_vm._s(_vm.file.name))]),
                  _vm._v(
                    " (" +
                      _vm._s(_vm.formatFileSize(_vm.file.size)) +
                      ").\n                Please confirm to proceed or cancel to select a different file.\n            "
                  ),
                ]),
              ]
            }),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.submitFile } },
              [_vm._v("Confirm")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary",
                on: { click: _vm.cancelUpload },
              },
              [_vm._v("Cancel")]
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.$props.hideProgress && _vm.file && _vm.uploading
      ? _c("div", [
          _c("p", [_vm._v("Uploading: " + _vm._s(_vm.uploadPercentage) + "%")]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }